<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站信息</span>
      </div>
      <el-form
        ref="firstForm"
        :model="firstForm"
        :rules="firstRules"
        label-width="100px"
        style="width: 500px"
      >
        <el-form-item label="名称" prop="whiteListName">
          <el-input
            v-model="firstForm.whiteListName"
            placeholder="请输入限制名称"
          />
        </el-form-item>
        <el-form-item label="限制站点" prop="isAll">
          <el-radio-group v-model="firstForm.isAll" @change="isAllSelect">
            <el-radio :label="'1'"> 选择运营商</el-radio>
            <el-radio :label="'2'">选择电站</el-radio>
          </el-radio-group>
        </el-form-item>
         <el-form-item v-if="firstForm.isAll=='1'" label="" prop="limiteSite2">
          <el-input placeholder="输入关键字进行过滤" v-model="tempText2" />
          <!-- <STree v-model="firstForm.limiteSite" :data="stationTree" style="width:400px;"></STree> -->
           <GoodStree
            @check="checkFn2"
            :tempText="tempText2"
            :data="stationData1"
            style="width:400px;"
          />
        </el-form-item>
        <el-form-item v-if="firstForm.isAll=='2'" label="" prop="limiteSite">
          <el-input placeholder="输入关键字进行过滤" v-model="tempText4" />
          <!-- <STree v-model="firstForm.limiteSite" :data="stationTree" style="width:400px;"></STree> -->
          <GoodStree
            @check="checkFn4"
            :tempText="tempText4"
            :data="stationTree"
            style="width:400px;"
          />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">限制规则</span>
      </div>
      <el-form
        ref="secondForm"
        :model="secondForm"
        :rules="secondRules"
        label-width="100px"
        style="width: 500px"
      >
        <el-form-item label="限制时间" prop="date">
          <el-date-picker
            v-model="secondForm.date"
            type="daterange"
            range-separator="至"
            start-placeholder="请选择时间"
            end-placeholder="请选择时间"
            value-format="yyyy-MM-dd"
            @change="handleChange"
          />
        </el-form-item>
        <el-form-item label="限制周天" prop="limiteWeek" style="width: 800px;">
          <el-checkbox-group v-model="secondForm.limiteWeek">
            <el-checkbox
              v-for="item in weekOptions"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="每日时段" style="width: 700px;" prop="startTime">
          <el-row>
            <el-col :span="11">
              <el-form-item prop="startTime">
                <el-time-select
                  v-model="secondForm.startTime"
                  style="width: 100%;"
                  placeholder="起始时间"
                  :picker-options="{
                    start: '00:00',
                    step: '00:30',
                    end: '24:00'
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: center;">至</el-col>
            <el-col :span="11">
              <el-form-item prop="endTime">
                <el-time-select
                  v-model="secondForm.endTime"
                  style="width: 100%;"
                  placeholder="结束时间"
                  :picker-options="{
                    start: '00:00',
                    step: '00:30',
                    end: '24:00',
                    minTime: secondForm.startTime
                  }"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">限制机构</span>
      </div>
      <el-form
        ref="lastForm"
        :model="lastForm"
        :rules="lastRules"
        label-width="100px"
        style="width: 500px"
      >
        <el-form-item label="限制用户" prop="userType">
          <el-radio-group
            v-model="lastForm.userType"
            @change="partakeCancelTree()"
          >
            <el-radio
              v-for="(item, index) in userTypeItem"
              :key="index"
              :label="item.id"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
          <el-input  v-show="lastForm.userType === '3'" type="textarea" v-model="lastForm.desc" ></el-input>
              <div style="font-size: 13px;color: #1890FF;" v-if="lastForm.userType === '3'">注：请输入用户的充电账号，多个账号之间用英文','隔开。</div>
          <!-- 选择企业 -->
          <div v-show="lastForm.userType === '1'" class="border">
            <el-input
              v-model="filterMechanismText"
              placeholder="输入关键字进行过滤"
            />
            <el-tree
              ref="treeMechanism"
              :data="mechanismTreeData"
              show-checkbox
              default-expand-all
              node-key="id"
              highlight-current
              :props="treeDefaultProps"
              :filter-node-method="filterNode"
              @check-change="handleMechanismChange"
              :check-strictly="true"
            />
          </div>
          <!-- 选择标签 -->
          <div v-show="lastForm.userType === '2'" class="border">
            <el-input
              v-model="filterTagText"
              placeholder="输入关键字进行过滤"
            />
            <el-tree
              ref="treeTag"
              :data="tagTreeData"
              show-checkbox
              default-expand-all
              node-key="id"
              highlight-current
              :props="treeDefaultProps"
              :filter-node-method="filterNode"
              @check-change="handleTagChange"
            />
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="el-card-never-btn">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST, EV_HOST } from "@/utils/host";
export default {
  name: "AddEnterprise",
  components: {},
  data() {
    return {
      tempText4:'',
      stationData1:[],
         userTypeItem: [
        {
          label: "选择企业",
          id: "1"
        },
        {
          label: "选择标签",
          id: "2"
        },
           {
          label: "输入单用户",
          id: "3"
        },
      ],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      treeDefaultProps: {
        children: "children",
        label: "name"
      },
      filterOperatorText: "", // 运营商过滤
      filterMechanismText: "", // 企业过滤
      filterTagText: "",
      tempText: "",
      tempText2: "",
      orgId:'',
      checkArr: [],
      checkArr2: [],
      checkArr4: [],
      weekOptions: [
        {
          label: "周日",
          value: "7"
        },
        {
          label: "周一",
          value: "1"
        },
        {
          label: "周二",
          value: "2"
        },
        {
          label: "周三",
          value: "3"
        },
        {
          label: "周四",
          value: "4"
        },
        {
          label: "周五",
          value: "5"
        },
        {
          label: "周六",
          value: "6"
        }
      ],
      firstForm: {
        isAll: '1',
        limiteSite: [],
        limiteSite2: [],
      },
      firstRules: {
        whiteListName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        isAll: [
          {
            required: true,
            message: "请选择运营商",
            trigger: "blur"
          }
        ],
        limiteSite: [
          {
            required: true,
            message: "请选择限制站点",
            trigger: "change"
          }
        ],
                limiteSite2: [
          {
            required: true,
            message: "请选择限制站点",
            trigger: "change"
          }
        ]
      },
      stationTree: [],
      secondForm: {
        date: [],
        limiteWeek: [],
        startTime: "",
        endTime: ""
      },
      secondRules: {
        date: [
          {
            required: true,
            message: "请选择限制时间",
            trigger: "blur"
          }
        ],
        limiteWeek: [
          {
            required: true,
            message: "请选择限制周天",
            trigger: ["blur", "change"]
          }
        ],
        startTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "blur"
          }
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
            trigger: "blur"
          }
        ]
      },
      lastForm: {
        userType: "1", // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: [],
        desc:'' // 选择标签
      },
      tempArr: [],
      lastRules: {},
      personTree: [],
      isStation: false
    };
  },
  computed: {
    headers() {
      return {
        token: window.localStorage.getItem("token")
      };
    },
    action() {
      return HOST + "/oss";
    }
  },
  mounted() {
    this.getStationTree();
    this.getUserTree();
    this.getTagTree();
    this.getMechanismTree();
    this.getOperator()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val);
    },
    filterTagText(val) {
      this.$refs.treeTag.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch("form/handle", {
        url: "/user/label/all",
        data: { orgType: "1,3", labelType: "0" },
        callback: resp => {
          this.tagTreeData = resp;
        }
      });
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch("form/handle", {
        url: "/setting/tree/org",
        data: { orgType: "1,3" },
        callback: resp => {
          this.mechanismTreeData = resp;
        }
      });
    },
    partakeCancelTree() {
      this.$refs.treeMechanism.setCheckedKeys([]);
      this.$refs.treeTag.setCheckedKeys([]);
    },
    // 选择企业 赋值
    handleMechanismChange(data, checked, indeterminate) {
      this.lastForm.mechanism = this.$refs.treeMechanism.getCheckedKeys();
    },
    // 选择标签 赋值
    handleTagChange(data, checked, indeterminate) {
      this.lastForm.tag = this.$refs.treeTag.getCheckedKeys();
    },
    checkFn(e) {
      this.checkArr = e;
    },
    checkFn2(e) {
      this.checkArr2 = e;
            this.firstForm.limiteSite2 = e;
      console.log(this.checkArr2,'eee');
    },
        checkFn4(e) {
          console.log(11111)
          console.log(e,'eee')
      this.checkArr4 = e;
      this.firstForm.limiteSite = e;
    },
    isAllSelect(val) {
      if (val) {
        this.isStation = false;
      } else {
        this.isStation = true;
        this.firstForm.limiteSite = [];
      }
    },

    handleChange(value) {
      this.secondFormlimiteWeek = [];
      this.weekOptions = [
        {
          label: "周日",
          value: "7"
        },
        {
          label: "周一",
          value: "1"
        },
        {
          label: "周二",
          value: "2"
        },
        {
          label: "周三",
          value: "3"
        },
        {
          label: "周四",
          value: "4"
        },
        {
          label: "周五",
          value: "5"
        },
        {
          label: "周六",
          value: "6"
        }
      ];
      if (!value) return;
      const weekList = [];
      var date1 = new Date(Date.parse(value[0].replace(/-/g, "/")));
      var date2 = new Date(Date.parse(value[1].replace(/-/g, "/")));
      var iDays = parseInt(
        Math.abs(date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
      );
      if (iDays >= 7) {
        this.weekOptions = [
          {
            label: "周日",
            value: "7"
          },
          {
            label: "周一",
            value: "1"
          },
          {
            label: "周二",
            value: "2"
          },
          {
            label: "周三",
            value: "3"
          },
          {
            label: "周四",
            value: "4"
          },
          {
            label: "周五",
            value: "5"
          },
          {
            label: "周六",
            value: "6"
          }
        ];
      } else if (iDays <= 0) {
        const indexone = new Date(value[0]).getDay();
        this.weekOptions.forEach((item, index) => {
          if (indexone == index) {
            weekList.push(item);
          }
        });
        this.weekOptions = weekList;
      } else {
        const indexone = new Date(value[0]).getDay();
        const indextwo = new Date(value[1]).getDay();
        this.weekOptions.forEach((item, index) => {
          if (indexone < indextwo) {
            if (indexone <= index) {
              if (indextwo >= index) {
                weekList.push(item);
              }
            }
          } else if (indexone > indextwo) {
            if (indexone <= index) {
              weekList.push(item);
            } else if (indextwo >= index) {
              weekList.push(item);
            }
          }
        });
        this.weekOptions = weekList;
      }
    },

    cancel() {
      this.$router.go(-1);
    },

    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.firstForm.validate(),
          this.$refs.secondForm.validate()
        ]);
      } catch (error) {
        return;
      }
      const week = this.secondForm.limiteWeek.join(",");
      if(this.lastForm.userType==1){
          this.orgId=this.lastForm.mechanism.join(',')
      }
      else if(this.lastForm.userType==2){
        this.orgId= this.lastForm.tag.join(',')
      }
      else{
         this.orgId= this.lastForm.desc
      }
      // const limiteSite = this.firstForm.limiteSite.join(',')
      // console.log(this.lastForm)
      // for (var j = 0; j < this.lastForm.orgId.length; j++) {
      //   for (var i = 0; i < this.tempArr.length; i++) {
      //     if (this.lastForm.orgId[j] == this.tempArr[i]) {
      //       this.lastForm.orgId.splice(j, 1)
      //     }
      //   }
      // }
      // const orgId = this.lastForm.orgId.join(',')
      // const orgId = this.checkArr.join(",");
      let limiteSite
      if(this.firstForm.isAll=='1'){
       limiteSite = this.checkArr2.join(",");
      } 
      else{
          limiteSite = this.checkArr4.join(",");
      }
      const data = {
        whiteListName: this.firstForm.whiteListName,
        limiteSite: limiteSite,
        isAll: '1',
        limiteStartDay: this.secondForm.date[0],
        limiteEndDay: this.secondForm.date[1],
        limiteWeek: week,
        limiteStartHour: this.secondForm.startTime,
        limiteEndHour: this.secondForm.endTime,
        orgId: this.orgId,
        userType:this.lastForm.userType,
        siteType:this.firstForm.isAll,
      };
      console.log(data, "data");

      this.$store.dispatch("form/handle", {
        url: "/business/whitelist/put",
        data: data,
        method: "put",
        callback: resp => {
          this.$router.go(-1);
        }
      });
    },

    getStationTree() {
      this.$store.dispatch("form/handle", {
        url: "/business/whitelist/getStationList",
        method: "get",
        callback: resp => {
          this.stationTree = resp;
        }
      });
    },
        getOperator() {
      const data = {
        attr: 0,
        orgTypes: "0,3",
        showOperatorName: true
      };
      this.$store.dispatch("form/handle", {
        url: "/business/discountterm/getResponsibleOrgTree",
        data: data,
        method: "get",
        callback: resp => {
          this.stationData1 = resp;
        }
      });
    },

    getUserTree() {
      this.$store.dispatch("form/handle", {
        url: "/business/whitelist/getOrgAndUser",
        method: "get",
        callback: resp => {
          this.personTree = resp;
          for (var i = 0; i < this.personTree.length; i++) {
            if (this.personTree[i].attrs) {
              this.tempArr.push(this.personTree[i].id);
            }
          }
        }
      });
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.iconfont {
  width: 50px;
  height: 50px;
  margin: auto;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
/deep/ .el-textarea__inner{
  min-height: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/addWhiteList.vue